import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { DashboardService, Widget } from '@app/gen/dashboard';
import { ThunkExtra } from '@app/store';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '../../dashboard.state';

export const changeUserWidget = createAsyncThunk<Widget, Widget, ThunkExtra>(
  'widgets/changeUserWidget',
  async (widget, { rejectWithValue, extra: { inject } }) => {
    try {
      const dashboardService = inject(DashboardService);

      await dashboardService.updateUserWidgetActiveState({
        body: {
          is_active: widget.is_active,
        },
        params: { widget_id: widget.id },
      });

      return widget;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const widgetsReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(changeUserWidget.pending, (state) => {
    state.widgets.status = 'loading';
  });
  builder.addCase(changeUserWidget.fulfilled, (state, { payload }) => {
    state.widgets.status = 'complete';
    state.layout = [
      ...state.layout.map((layoutItem) => {
        if (layoutItem.type === payload.type) {
          return { ...layoutItem, switched_on: !layoutItem.is_active };
        }

        return layoutItem;
      }),
    ];
  });
  builder.addCase(changeUserWidget.rejected, (state, { payload, error }) => {
    state.widgets.status = 'failed';
    state.widgets.error =
      payload ||
      ({
        info: (error && error.message) || 'Что-то пошло не так',
        status: 500,
        source: 'client',
        title: 'Internal client error',
      } as AppError);
  });
};
